export const partners = [
    {
      name: "Evently",
      image: "/assets/images/partners/evently.png",
      link: "https://evently.ph"
    },
    {
      name: "Bride Worthy",
      image: "/assets/images/partners/bw.png",
    },
  ];